import React, { useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";
import CustomSearchInput from "../../components/linksComponents/CustomSearchInput";
import DatePickerWithOptions from "../../components/linksComponents/DatePickerWithOptions";
import CampaignsLinksView from "./CampaignsLinksView";
import CampaignOverview from "./CampaignOverview";

const CampaignsPageContent = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  totalPages,
  setPage,
  page,
  setSort,
  searchInputValue,
  sort,
  handleSearchInputValue,
  campaigns,
  handleSelectedCampaign,
  archived,
  months,
  setMonths,
  handleOptionSelect,
}) => {
  return (
    <Container>
      <Line style={{ zIndex: "3" }}>
        <CustomSearchInput
          id="audienceSearchInput"
          style={{ maxWidth: "300px" }}
          value={searchInputValue}
          setValue={handleSearchInputValue}
          palceholder="Search"
        />
        <Line style={{ marginLeft: "auto" }}>
          <DatePickerWithOptions
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            months={months}
            setMonths={setMonths}
            handleOptionSelect={handleOptionSelect}
          />
        </Line>
      </Line>
      <CampaignOverview
        startDate={startDate}
        endDate={endDate}
        archived={archived}
      />
      <Separator />
      <CampaignsLinksView
        totalPages={totalPages}
        setPage={setPage}
        page={page}
        setSort={setSort}
        campaigns={campaigns}
        sort={sort}
        handleSelectedCampaign={handleSelectedCampaign}
      />
    </Container>
  );
};

export default CampaignsPageContent;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  h2 {
    width: 100%;
  }
  gap: 30px;
`;

const Separator = styled.div`
  display: flex;
  height: 1px;
  min-height: 1px;
  width: 100%;
  background: ${lightThemeColors.darkColor};
  opacity: 0.1;
`;
const Line = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;
